import AppLayout from './AppLayout';
import ErrorPage from '@components/common/ErrorPage';
import PropTypes from 'prop-types';
import React from 'react';
import {AdapterLuxon} from '@mui/x-date-pickers/AdapterLuxon';
import {ErrorBoundary} from '@sentry/react';
import {Helmet, HelmetProvider} from 'react-helmet-async';
import {LocalizationProvider} from '@mui/x-date-pickers-pro';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {ReactQueryDevtools} from '@tanstack/react-query-devtools';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const TITLE = 'Planet Account';

const HelmetStuff = ({children}) => (
  <HelmetProvider>
    <Helmet defaultTitle={TITLE} titleTemplate={`%s - ${TITLE}`} />
    {children}
  </HelmetProvider>
);

HelmetStuff.propTypes = {
  children: PropTypes.node,
};

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <LocalizationProvider dateAdapter={AdapterLuxon}>
        <HelmetStuff>
          <ErrorBoundary fallback={<ErrorPage />}>
            <AppLayout />
          </ErrorBoundary>
        </HelmetStuff>
      </LocalizationProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
};

export default App;
